import { Component, Input } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { IFormDropDownItem } from "src/app/common-components/form-controls/form-dropdown/dropdown.component";
import { NoteAcknowledged, NoteDisplayLevelMobile, NoteDisplayLevel } from "src/app/web-api/web-api";

export class WawiApiNoteFacilityUpdateFormGroup extends FormGroup {
  public static get Note_MaxLength() {
    return 1000;
  }

  public constructor(fb: FormBuilder) {
    super({
      noteID: fb.control("", Validators.required),
      displayLevelMobile: fb.control(NoteDisplayLevelMobile.Display, Validators.required),
      acknowledgedOnMobile: fb.control(NoteAcknowledged.Unread),
      note: fb.control(
        "",
        Validators.compose([
          Validators.required,
          Validators.maxLength(
            WawiApiNoteFacilityUpdateFormGroup.Note_MaxLength
          ),
        ])
      ),
      displayLevel: fb.control("", Validators.required),
    });
  }

  public get noteID(): FormControl {
    return this.controls.noteID as FormControl;
  }
  public get note(): FormControl {
    return this.controls.note as FormControl;
  }
  public get displayLevelMobile():FormControl{
    return this.controls.displayLevelMobile as FormControl;
  }
  public get acknowledgedOnMobile():FormControl{
    return this.controls.acknowledgedOnMobile as FormControl;
  }

  public get displayLevel(): FormControl{
    return this.controls.displayLevel as FormControl;
  }

}

@Component({
    selector: "app-wawi-note-facility-update-form",
    templateUrl: "./note-facility-update-form.component.html",
    styleUrls: ["./note-facility-update-form.component.scss"],
    standalone: false
})
export class WawiApiNoteFacilityUpdateFormComponent {
  public noteAcknowledged = NoteAcknowledged;
  public noteDisplayLevelMobileType = NoteDisplayLevelMobile;

  public NoteDisplaylevelType = NoteDisplayLevel;

  displayLevel: Array<IFormDropDownItem> =[  
    {
      label: $localize`:@@NoteDisplayLevel_Standard:Standard`,
      value: this.NoteDisplaylevelType.Standard,
    },
    {
      label: $localize`:@@NoteDisplayLevel_Hervorgehoben:Hervorgehoben`,
      value: this.NoteDisplaylevelType.Hervorgehoben,
    },
    {
      label: $localize`:@@NoteDisplayLevel_AktivAnzeigen:Aktiv anzeigen`,
      value: this.NoteDisplaylevelType.AktivAnzeigen,
    },
  ];

  @Input() form: WawiApiNoteFacilityUpdateFormGroup;
}
